import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes, BrowserRouter } from "react-router-dom";



import Box from '@mui/material/Box';

import { Auth0Provider } from '@auth0/auth0-react';

import './index.scss';

import './home';

// import { Title } from '@mui/icons-material';
import Home from './home';
import LoginPage from './login-page';
import { AuthenticationGuard } from './authentication-guard';
// import { loading_page } from './loading-page';
   

  export default function Page() {

    return (
        <BrowserRouter>
            <Box sx={{ width: '100%', typography: 'body1',whiteSpace: 'pre-line' }}>
                <Auth0Provider
                    domain="paccarsolutions.login-cert.paccar.com"
                    clientId="bdXMZ7nSsyqE1DBjqHXcUtGtktYfDWV7"
                    authorizationParams={{
                        redirect_uri: window.location.origin + "/home"   
                    }} 
                >
                    <Routes>
                        <Route path="/" element={<LoginPage />} />
                        <Route path="/home" element={<AuthenticationGuard component={Home} />} />

                    </Routes>
                </Auth0Provider>
            </Box>
        </BrowserRouter>
    )
    
  }

    // ========================================
  
  const root = ReactDOM.createRoot(document.getElementById("root")!);
  root.render(<Page />);
  